import { render, staticRenderFns } from "./MesecnaPretplata.vue?vue&type=template&id=12dcb060&"
import script from "./MesecnaPretplata.vue?vue&type=script&lang=js&"
export * from "./MesecnaPretplata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports